import { CostReviewBaseAttributes } from './CostReviewBaseAttributes';
import { NewCostReviewAttributesBase } from './NewCostReviewAttributesBase';
import { CostReviewerDetails } from './CostReviewerDetails';
export class CostReviewDatabaseRecord {
  estimateId!: string;
  description!: string;
  requesterNotes!: string;
  openDate!: Date;
  tdcDollars!: number | null;
  status!: number | null;
  approvedSellPrice!: number | null;
  reviewObject!: CostReviewBaseAttributes;
  modifiedBy!: string;
  autoSendEmail!: boolean;
  reportOne!: string;
  reportTwo!: string;
  reportThree!: string;
  approvedMarginPercent!: number | null;
  installType!: number | null;
  trrStatus!: string;
  newReviewObject!: NewCostReviewAttributesBase;
  ccUser!: string;
  reviewerTypeId!: number | null;
  reviewerName!: string;
  reviewerEmail!: string;
  reviewerUserId!: string;
  requiredBy!: string;
  closeDate!: Date;
  reviewerComments!: string;
  modifiedDate!: Date;
  isSellPriceChange!: boolean;
  isReviewerReplaced!: boolean;
  autoUnlockByMargin!: boolean;
  autoUnlockBySellPrice!: boolean;
  currentSellPrice!: number;
  currentMargin!: number;
  version!: string;
  costReviewers!: CostReviewerDetails[];
}
